import { defineMessages } from "react-intl";

export const messages = defineMessages({
  searchAllColumns: {
    id: "placeholder.searchAllColumns",
    defaultMessage: "Search All Columns",
  },
  copyUOM: {
    id: "confirmation.copyUOM",
    defaultMessage:
      "Copying UOM will overwrite UOM list and their active status. Do you wish to continue?",
  },
});
